import { compose } from 'lodash/fp';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getServiceProducts } from '@mews-commander/legacy-entities/src/selectors/products';
import {
    getCheckedReservationIds,
    getFirstCheckedReservation,
    getFirstCheckedReservationServiceId,
    areOrderItemsFetching,
    hasOrderItemsFetchingFailed,
} from '../../selectors/reservationModuleState';
import { fetchCurrentEnterpriseCheckedReservations, initializeStateTab } from '../../actions';
import withReservationsSameService from '../withReservationsSameService';
import { RESERVATION_ORDER_ITEMS_EXTENT } from '../../constants';

export default compose(
    connect(
        // @ts-expect-error $TSFixMeError: No overload matches this call.
        createStructuredSelector({
            serviceProducts: (state: $TSFixMe, { scope }: $TSFixMe) => {
                const serviceId = getFirstCheckedReservationServiceId(state, { scope });

                // @ts-expect-error $TSFixMeError: Type 'string | undefined' is not assignable to type 'string'.
                return getServiceProducts(state, { serviceId });
            },
            isFetching: areOrderItemsFetching,
            hasFailed: hasOrderItemsFetchingFailed,
            reservationIds: getCheckedReservationIds,
            checkedReservation: getFirstCheckedReservation,
            serviceId: getFirstCheckedReservationServiceId,
        }),
        // @ts-expect-error $TSFixMeError: Property 'scope' does not exist on type '{}'.
        (dispatch, { scope }) => ({
            refetchGroup: async () =>
                Promise.all([
                    dispatch(
                        // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe, getState: $TSFixMe) => any' is not assignable to parameter of type 'Action<any>'.
                        fetchCurrentEnterpriseCheckedReservations({ scope, extent: RESERVATION_ORDER_ITEMS_EXTENT })
                    ),
                    // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe, getState: $TSFixMe) => Promise<void | [any, any]>' is not assignable to parameter...
                    dispatch(initializeStateTab({ scope })),
                ]),
        })
    ),
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    withReservationsSameService
);
